import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/customer/invoice/address/save',
    data: form,
    method: 'post'
  })

export const remove = (id) => axios.request({
    url: `customer/invoice/address/delete/${id}`,
    method: 'delete'
  })
export const all = (form) => axios.request({
    url: '/customer/invoice/address/all',
    data: form,
    method: 'post'
  })